/**
 * @ngdoc controller
 * @name MediaController
 * @description
 * This component renders the Media section.
 *
 * @memberof media
 */
class MediaController {
  /**
   * Class constructor
   * @param {Service} $q               To access the angular promise service.
   * @param {Object}  $rootScope       To broadcast the tracking events.
   * @param {Service} $window          To access the history API.
   * @param {Service} campaignsService To get a media of a campaign by Id.
   * @param {Service} profileService   To get the list of media of the user.
   * @param {Service} communityService To get the list of media of the community.
   * @param {Service} errorHandler     To show any errors.
   * @param {Object}  TRACKING_EVENTS  To get the name of the events to be broadcasted.
   * @ignore
   */
  constructor(
    $q,
    $rootScope,
    $window,
    campaignsService,
    profileService,
    communityService,
    errorHandler,
    TRACKING_EVENTS,
  ) {
    'ngInject';

    /**
     * The local reference to the `$q` service.
     * @type {Object}
     */
    this.$q = $q;
    /**
     * The local reference to the `$rootScope` object.
     * @type {Object}
     */
    this.$rootScope = $rootScope;
    /**
     * The local reference to the `$window` service.
     * @type {Object}
     */
    this.$window = $window;
    /**
     * The local reference to the `campaignsService` service.
     * @type {Object}
     */
    this.campaignsService = campaignsService;
    /**
     * The local reference to the `profileService` service.
     * @type {Object}
     */
    this.profileService = profileService;
    /**
     * The local reference to the `communityService` service.
     * @type {Object}
     */
    this.communityService = communityService;
    /**
     * The local reference to the `errorHandler` service.
     * @type {Object}
     */
    this.errorHandler = errorHandler;
    /**
     * The local reference to the `TRACKING_EVENTS` constant.
     * @type {Object}
     */
    this.TRACKING_EVENTS = TRACKING_EVENTS;
    /**
     * The local reference to the `media` object.
     * @type {Null|Object}
     */
    this.media = null;
    /**
     * The local reference to the `campaign` object.
     * @type {Null|Object}
     */
    this.campaign = null;
  }
  /**
   * Initialize variables
   */
  $onInit() {
    this.getMedia()
    .then((media) => {
      this.media = media;
    })
    .catch((err) => this.errorHandler.handleError(err));
  }
  getMedia() {
    let promise;

    switch (this.type) {
    case 'campaign':
      promise = this.campaignsService.getCampaignById(this.campaignId)
      .then((campaign) => {
        this.campaign = campaign;
        return this.campaign.getMediaById(this.mediaId);
      });
      break;
    case 'community':
      promise = this.communityService.getMediaById(this.mediaId);
      break;
    case 'profile':
      promise = this.profileService.getMediaById(this.mediaId);
      break;
    default:
      break;
    }

    return promise || this.$q.reject(new Error('Media could not be fetched.'));
  }
  /**
   * Callback function to be called when the close button is clicked.
   */
  onCloseButtonClick() {
    this.$rootScope.$broadcast(this.TRACKING_EVENTS.photo.clickClose);
    this.$window.history.back();
  }
}

export default MediaController;



// WEBPACK FOOTER //
// ./src/frontend/modules/media/components/media/media.controller.js